import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'
import NavbarNotAuth from '../components/navbarNotAuth'

function Matera() {
    return (<>
    {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div style={{marginTop:'6rem'}}></div>
        <App />

        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Matera</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>BASILICATA
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>CULTURA
                    </span>
                </h5>
            </div>
        </div>
        <div className='mt-1'>
            <div className='galleria container-fluid'>
                <div className='gbox1'>
                    <img src={require('../image/moira-nazzari-BY25ED6PSJk-unsplash.jpg')}
                        height='100%' width='100%' alt='' />
                </div>
                <div className='gbox2'>
                    <h4>La città dei sassi</h4><hr />
                    <p className='mt-3'>
                        <b>Matera</b> si innalza ad un'altezza di 401 metri sopra il livello del mare e si trova in prossimità
                        dell'altopiano delle Murge. La città detiene un patrimonio culturale e storico unico al mondo.
                        Al di sotto della sua piazza è possibile visitare un acquedotto del XVI secolo <i>(Matera sotterranea)</i>, con cisterne tra le più
                        grandi d'Europa che raccolgono l'acqua piovana.
                        All'interno delle sue rocce, invece, sono state scavate e ricavate case, chiese rupestri e cantine popolate dall'uomo
                        per un periodo di tempo che va dal Paleolitico fino al 1952.
                    </p>
                    <hr /><br />
                    <p>
                        Il <b>Presepe vivente</b> di Matera offre una rappresentazione molto suggestiva della nascita
                        di Gesù con lo scenario storicamente favoloso dei <b>Sassi</b>.
                        Partendo dal centro storico e proseguendo verso il <b>Sasso Caveoso</b>, il percorso lungo 1.5 km
                        offrirà la presenza di oltre 200 figuranti che rievocheranno la magia del Natale.
                        Matera, denominata anche <i>la Gerusalemme del sud Italia</i> e ispiratrice del grande cinema, metterà
                        a disposizione le sue vie più iconiche per questa stupenda rappresentazione.
                    </p>

                </div>
                <img src={require('../image/freysteinn-g-jonsson-q4BcenFF3dU-unsplash.jpg')}
                    alt='' className='galleria_immagine addImg' />
                <img src={require('../image/luca-micheli-42fS8_aq5oQ-unsplash.jpg')}
                    alt='' className='galleria_immagine addImg' />
            </div>

            <p className='m-3'>
                Matera è una provincia della basilicata ed è conosciuta in tutto il mondo per i suoi storici <b>Sassi</b> che
                identificano i 2 principali rioni: <i>Sasso Barisano e Sasso Caveoso</i>. La particolarità storica è che gli edifici
                non sono stati edificati ma sono stati ricavati scavando la roccia tufica presente in abbondanza nella città.
                I Sassi di Matera rientrano nel <b>Patrimonio dell'umanità UNESCO</b> dal 1993.

            </p>

            <div className='container mt-2'>

                <div className='divCittà mt-5'>
                    <h1 className='text-center'>IL SASSO CAVEOSO</h1>
                    <img src={require('../image/adelio-rQE8yHmYFbA-unsplash.jpg')}
                        alt='' className='imgCittà' />
                    <br />
                    <p className='mt-3'>
                        La piccola città di Matera si trova in Basilicata ed attira turisti da tutto il mondo grazie
                        alla presenza dei suoi famosi <b>Sassi</b> che la rendono una delle città più visitate d'Italia.
                        <mark>Patrimonio UNESCO dal 1993</mark>, dopo secoli di povertà, oblio e trascuratezza, la città
                        riuscì magicamente a farsi riconoscere una potenza culturale e storica senza precedenti.
                        Le prime tracce umane all'interno dei Sassi di Matera risalgono al <b>Paleolitico</b>.
                        Numerosi studi hanno dimostrato essere uno degli insediamenti più antichi e duraturi mai esistiti
                        sulla terra a tal punto che fino al 1952 alcuni abitanti risiedevano ancora nelle grotte preistoriche.
                        La conformazione tufacea della roccia ha permesso all'uomo di scavare nel corso dei milenni senza
                        particolari difficoltà e di creare rifugi contro le pioggie e le intemperie.
                        Il <b>Sasso Caveoso</b>, in tal modo nominato per il suo riferimento alla parola <i>cavea</i> ovvero
                        cavità, grotta, è un rione in cui quasi tutte le abitazioni sono state scavate nella roccia.
                        Cose de vedere nel Sasso Caveoso:<br />
                        <b>- Chiesa di San Pietro Caveoso</b>, una chiesa scavata nella roccia nella piazza panoramica.<br />
                        <b>- Chiesa della Madonna dell'Idris</b> e la <b>Chiesa di San Giovanni in Monterrone, </b>
                        entrambe chiese rupestri.<br />
                        <b>- Casa Grotta</b>, una casa abitata fino al 1957 con gli arredi originali per rendersi conto di come
                        vivevano in quegli ambienti umidi e freddi.<br />
                        <b>- Duomo</b>, risalente al 1200 ed edificato nel punto più alto.
                    </p>
                </div>

                <div className='divCittà mt-5'>
                    <h1 className='text-center'>SASSO BARISANO</h1>
                    <img src={require('../image/moira-nazzari-BY25ED6PSJk-unsplash.jpg')}
                        alt='' className='imgCittà' />
                    <br />
                    <p className='mt-3'>
                        Il nome del rione denominato <b>Sasso Barisano</b> deriva probabilmente dal fatto che è posto
                        geograficamente in direzione della città di Bari.
                        In questo quartiere si concentrano di più gli hotel, i ristoranti ed i negozi di souvenir
                        e di oggettistica locale in tufo, terracotta e legno.
                        Cose da vedere nel Sasso Barisano:<br />
                        <b>- Chiesa di San Pietro Barisano</b> in stile romanico/barocco, è la più grande chiesa rupestre
                        di Matera.<br />
                        <b>- Chiesa di Sant'Agostino e la Cripta di San Giuliano</b>, edificata nel punto più alto
                        da dove poter ammirare il favoloso panorama dei Sassi.
                        Matera, storia e mitologia tra set cinematrografici e racconti di storie vere...un Incanto e una meraviglia.
                    </p>
                </div>

                <div className='divCittà mt-5'>
                    <h1 className='text-center'>PRESEPE VIVENTE</h1>
                    <img src={require('../image/michele-scala-v_4Y0kbbDCw-unsplash.jpg')}
                        alt='' className='imgCittà' />
                    <br />
                    <p className='mt-3'>
                        Nei suggestivi "Sassi di Matera" si svolge da molti anni la rappresentazione del <b>Presepe vivente</b> dove
                        antichi mestieri e momenti di vita comune saranno riprodotti con cura e realismo dai figuranti.
                        La via che ospita l'evento si estende per una lunghezza di 1.5 km e parte dal centro storico di Matera fino
                        ad arrivare al maestoso <b>Sasso Caveoso</b>.
                        L'animazione prevede la collaborazione di scuole teatrali di tutta Italia e la presenza di oltre 200 comparse.
                        La città, già convalidata come la <b>Gerusalemme del sud Italia</b>, offrirà uno spettacolo coinvolegente
                        ed emozionante per le viuzze che hanno fatto anche da cornice al grande cinema.



                    </p>
                </div>

                <div className='divCittà mt-5'>
                    <h1 className='text-center'>GASTRONOMIA</h1>
                    <img src={require('../image/gabriel-tovar-TPDfnKAKbVc-unsplash.jpg')}
                        alt='' className='imgCittà' />
                    <br />
                    <ul className='mt-3'>
                        <li>
                            <b>Pane di Matera</b>, antico e genuino da assaporare ad ogni pasto.
                        </li>
                        <li>
                            <b>La Cialledda</b>, pane ammorbidito con acqua e condito con vari ingredienti
                            semplici, tra i quali immancabile è la cipolla e l'olio.
                        </li>
                        <li>
                            <b>Pane cotto con le rape</b>, il pane viene cotto nell'acqua di cottura delle rape
                            e questo amalgama i due sapori formando un abbinamento perfetto, da provare!
                        </li>
                        <li>
                            <b>Fave e cicorie</b>, insieme alla cicoria viene servita una purea di fave.
                            Anche in questo caso si tratta di un piatto molto semplice ma gustosissimo!
                        </li>
                        <li>
                            <b>La Pignata</b>, la cui preparazione è molto particolare:
                            all'interno di un vaso di argilla viene messa la carne di pecora insieme a patate e
                            varie verdure aromatiche. Il vaso viene sigillato con un impasto di pizza o pane,
                            cotto lentamente per molte ore in un forno a legna.
                            A fine cottura l'impasto, che fa da coperchio, sarà lievitato con una forma simile al cappello di un fungo.
                        </li>
                        <li>
                            <b>Le Cancelle</b>, sono i Taralli dal gusto tipico del 'finocchietto'.
                        </li>
                        <li>
                            <b>Le Pettole</b>, un impasto salato che viene fritto in olio locale
                            dalla forma tipica di una ciambellina o a pallina.
                        </li>
                        <li>
                            <b>Le Cartellate</b>, rappresentano il dolce principale della tradizione culinaria materana.
                            Sono preparate da un impasto dolce, fritto in olio e condito con miele e zuccherini.
                            Se siete in visita nella città nel periodo natalizio e avete voglia di un dolcetto,
                            queste prelibatezze fanno al caso vostro!
                        </li>
                    </ul>
                </div>
            </div>
            <DivBottom />
        </div>

    </>)
}
export default Matera